import { withAsyncContext as _withAsyncContext, defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue";
import { Team } from "@/modules/team/entity";
import { BankLog } from "@/modules/finances/entity";
import FinanceLayout from "@/modules/finances/pages/FinanceLayout.vue";
import Logs from "@/modules/finances/components/Logs.vue";
export default /*#__PURE__*/_defineComponent({
  __name: 'LogsYearlyPage',
  async setup(__props) {
    let __temp, __restore;
    const team = ref(([__temp, __restore] = _withAsyncContext(() => Team.current()), __temp = await __temp, __restore(), __temp));
    const logs = ref(([__temp, __restore] = _withAsyncContext(() => BankLog.createQueryBuilder('log').innerJoinAndSelect('log.season', 'season').andWhere('season.current = true').orderBy('log.id').getMany()), __temp = await __temp, __restore(), __temp));
    return (_ctx, _cache) => {
      return _openBlock(), _createBlock(FinanceLayout, null, {
        title: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('bank')), 1)]),
        default: _withCtx(() => [_createVNode(Logs, {
          balance: team.value.balance,
          logs: logs.value
        }, null, 8, ["balance", "logs"])]),
        _: 1
      });
    };
  }
});